exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe[data-v-5b1f0e45]{height:100%!important}", ""]);

// exports
